import moment from 'moment';
import { VIEWS, EditMode, TASK_SOURCE, PLanningMode } from '../../../../HelperMethods/constants';
import { getDateRange } from '../../../../HelperMethods/LocalStorageUtils';

const planningMinDate = moment().add(1, 'days').format('YYYY-MM-DD');

const startDateLte = moment().add(1, 'days').format('YYYY-MM-DD');

const startTimeLte = '00:00';

const maxPlanningDays = 14;

const planningMaxDate = moment().add(maxPlanningDays, 'days').format('YYYY-MM-DD');

const planningBaseTime = '06:00';

const initialState = {
  tasks: {
    items: [],
    isLoading: false,
    taskSource: TASK_SOURCE.NON_SUBSCRIPTION,
  },
  users: {
    items: [],
    isLoading: false,
  },
  usersAtFieldLevel: [],
  pageLoading: false,
  selectedDateRange: getDateRange(),
  planningMinDate,
  planningStartDate: planningMinDate,
  planningMaxDate,
  planningEndDate: planningMaxDate,
  startTimeLte,
  startDateLte,
  maxPlanningDays,
  planningBaseTime,
  scheduler: {
    startDate: moment().subtract(1, 'days').startOf('day').toDate(),
    endDate: moment().add(2, 'days').endOf('day').toDate(),
  },
  iframepresentState: false,
  currentView: VIEWS.taskGridView,
  viewStack: [VIEWS.taskGridView, VIEWS.taskGridView],
  tasksEditMode: EditMode.PUBLISHED,
  tasksPlanningState: PLanningMode.PLANNINGPUBLISHED,
  tasksPlanningMessage: '',
  filters: {
    items: [],
  },
  parentChildTasks: {
    items: [],
  },
  bulkEditTasks: {
    items: [],
    component: {},
    isLoading: false,
  },
  selectedUserIds: [],
  filteredUserIdsFromTaskListFilter: [],
  schedulerPageLoading: false,
  watcherDetailsDict: {},
  assetLevelsDict: {},
};

export default initialState;
